/**
 * 云服务类别 产品实例列表/实例图表页 告警策略/监控项详情Drawer层
 *
 * @format
 */

import React, { useMemo } from 'react'
import { _$, Drawer, Button } from '@king-design/react'
import DrawerMonitorDetails from './DrawerMonitorDetails'
import DrawerAlarmStrate from './DrawerAlarmStrate'
import { DrawerProps } from 'src/pages/MonitorCloud/constants'

const DrawerContainer: React.FC<DrawerProps> = props => {
  const handleClose = value => {
    if (!value) {
      props.closeDrawer()
    }
  }

  const title = useMemo(() => {
    return props.type === 'monitor' ? _$('监控项详情') : _$('告警策略详情')
  }, [props.type])

  const content = useMemo(() => {
    return props.type === 'monitor' ? (
      <DrawerMonitorDetails {...props} />
    ) : (
      <DrawerAlarmStrate {...props} />
    )
  }, [props.type])

  return (
    <Drawer
      title={title}
      width={600}
      value={props.visible}
      onChangeValue={handleClose}
      slotFooter={<Button onClick={props.closeDrawer}>{_$('关闭')}</Button>}
    >
      {content}
    </Drawer>
  )
}

export default DrawerContainer
